export default __webpack_public_path__ + "static/media/B1.7bd558f5.jpg";